import { Avatar, IconButton, Tooltip } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import React from "react";

type Props = {
    photoUrl?: string | null;
    firstName?: string | null;
    open: boolean;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function ProfileAvatarButton({ photoUrl, firstName, open, onClick }: Props) {
    return (
        <Tooltip title="Account settings">
            <IconButton
                onClick={onClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
            >
                {photoUrl ? (
                    <Avatar
                        src={photoUrl}
                        alt={firstName || "User"}
                        sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid var(--primary-color)",
                        }}
                    />
                ) : (
                    <AccountCircle
                        sx={{
                            color: "var(--primary-color)",
                            fontSize: 40,
                            border: "2px solid var(--primary-color)",
                            borderRadius: "50%",
                        }}
                    />
                )}
            </IconButton>
        </Tooltip>
    );
}
